import { useImmerAtom } from 'jotai-immer';
import {
    monitorStatusTableViewAtom,
    monitorStatusTableFiltersAtom,
    monitorStatusTableStatsAtom,
    monitorStatusTableStateAtom,
} from './monitorstatus_atoms';
import { useCallback } from 'react';
import { TblPagination, TblSortDir } from '../../../../core/table/table.types';
import { tblSpecSetFilter, tblSpecSetSort } from '../../../../core/table/spec';

export const useMonitorStatusTableState = (): any => {
    const [state] = useImmerAtom(monitorStatusTableStateAtom);
    const [view, setView] = useImmerAtom(monitorStatusTableViewAtom);
    const [filters, setFilters] = useImmerAtom(monitorStatusTableFiltersAtom);
    const [stats, setStats] = useImmerAtom(monitorStatusTableStatsAtom);

    const setPaging = useCallback(
        (paging: Partial<TblPagination>): void => {
            setStats(draft => {
                if (paging.page !== undefined) draft.paging.page = paging.page;
                if (paging.size !== undefined) draft.paging.size = paging.size;
                if (paging.total !== undefined) draft.paging.total = paging.total;
            });
        },
        [setStats],
    );

    const setSort = useCallback(
        (col: string, dir?: TblSortDir): void => {
            setView(draft => {
                draft.sort = tblSpecSetSort(col, view.cols, dir);
            });
        },
        [setView, view.cols],
    );

    const setFilter = useCallback(
        (key: string, val: any): void => {
            setFilters(draft => tblSpecSetFilter(draft, key, view.cols, val));
        },
        [setFilters, view.cols],
    );

    return {
        waiting: state.waiting,
        cols: view.cols,
        sections: view.sections,
        sort: view.sort,
        filters,
        fltStats: stats.fltStats,
        paging: stats.paging,
        setSort,
        setFilter,
        setPaging,
    };
};
